import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import styles from '../../styles/LoadingSkeletons.module.css';

const skeletonSx = { bgcolor: 'rgba(255, 255, 255, 0.08)' };

const GameCardSkeleton = () => (
  <div className={styles.gameCardSkeleton} aria-hidden="true">
    <div className={styles.gameCardHeader}>
      <Skeleton variant="text" width="55%" height={20} sx={skeletonSx} />
    </div>
    <div className={styles.gameCardRow}>
      <Skeleton variant="text" width="80%" height={24} sx={skeletonSx} />
      <Skeleton variant="rounded" width={88} height={36} sx={skeletonSx} />
      <Skeleton variant="rounded" width={88} height={36} sx={skeletonSx} />
    </div>
    <div className={styles.gameCardRow}>
      <Skeleton variant="text" width="75%" height={24} sx={skeletonSx} />
      <Skeleton variant="rounded" width={88} height={36} sx={skeletonSx} />
      <Skeleton variant="rounded" width={88} height={36} sx={skeletonSx} />
    </div>
  </div>
);

export const GameCardSkeletonGrid = ({ count = 6 }) => (
  <div
    className={styles.gameCardGrid}
    role="status"
    aria-live="polite"
    aria-label="Loading games"
  >
    {Array.from({ length: count }, (_, index) => (
      <GameCardSkeleton key={`game-skeleton-${index}`} />
    ))}
  </div>
);

GameCardSkeletonGrid.propTypes = {
  count: PropTypes.number,
};

export default GameCardSkeletonGrid;
